import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { msalInstance } from './auth/msalConfig';
import { App } from './App';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The kiosk poll is the device's heartbeat (CLAUDE.md §8). Configure
      // per-route as Phase 2 lands; sensible defaults for the management UI.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize MSAL before rendering — the v3 best practice. Without this,
// handleRedirectPromise() may race with the first render and silently lose
// the auth response.
msalInstance.initialize().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>,
  );
});
